module.exports = __webpack_public_path__ + "img/Img_Home_BuenFin.7e90a8ea.png";